import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export type CommunicationPreferencesFormType = {
    code: string;
    name: string;
    description: string;
    frequency: string;
}

type CommunicationPreferencesApiReturn = {
    isSuccess: boolean;
    data: CommunicationPreferencesFormType[];
    errorMessages: string | null;
    exception: string | null;
}

const useCommunicationPreferencesConfig = (): UseQueryResult<CommunicationPreferencesApiReturn> => {
    const endpoint = '/api/Members/communicationpreferences/config';

    const communicationPreferencesConfigQuery = useQuery<CommunicationPreferencesApiReturn>({
        queryKey: ['communicationPreferencesConfig'],
        queryFn: async() => {
            const response = await fetch(endpoint);
            if (!response.ok) {
                throw new Error('Failed to fetch communication preferences config');
            }
            return response.json();
        },
        staleTime: Number.POSITIVE_INFINITY,
    });

    return communicationPreferencesConfigQuery;
};

export default useCommunicationPreferencesConfig;
